import React from "react";
import {useAppStore} from "../../common/app.store.consumer";
import { CIHComponent } from "../types/CIH.component";

const CIHFooter: React.FC<CIHComponent> = useAppStore()((props: CIHComponent) => {
	const store = props.appStore.layoutStore;

	if (!store.isLayoutLoaded) {
		return null;
	}
	return <div className="cih-hide-print" dangerouslySetInnerHTML={store.CIHFooterMarkup} />;
});

export default CIHFooter;
